import { connect, ConnectedProps } from 'react-redux';
import { ReactNode } from 'react';
import pageHeader from './page-header';
import { RootState } from '../../../../../store/root-reducer';

const mapStateToProps = (state: RootState) => ({
  pageHeaderBannerMessage: state.pageHeader.message,
});

const connector = connect(mapStateToProps);

export type IProps = ConnectedProps<typeof connector> & {
  title: string;
  children?: ReactNode;
  heading?: ReactNode;
};

export default connector(pageHeader);
